/**
 * Pure re-flush decision for the chat transcript flush.
 *
 * Extracted from useChatSession.flushTranscript so node:test (and the
 * customer sanity suite) can verify the policy without a DOM/React runtime.
 * Keeping it pure also means the widget and the tests exercise the EXACT
 * same logic.
 *
 * Policy: the transcript may be flushed more than once so the stored copy
 * stays fresh (flush-on-lead, then a fuller flush at close), but we avoid
 * redundant POSTs. The SERVER dedupes the actual n8n send, so re-flushing
 * only refreshes the stored row and never re-processes a captured lead.
 *
 *   • Never flushed yet            → flush.
 *   • Already flushed 'completed'  → stop (terminal; session is done).
 *   • Otherwise                    → flush only if the transcript GREW, or
 *                                     the outcome escalates abandoned→completed.
 */

/**
 * @param {{ count: number, outcome: 'completed' | 'abandoned' } | null} prev
 *   Snapshot of the last flush, or null if nothing has been flushed yet.
 * @param {number} count Transcript message count of the new payload.
 * @param {'completed' | 'abandoned'} outcome Outcome of the new flush.
 * @returns {boolean} Whether this flush should actually be sent.
 */
export function shouldFlush(prev, count, outcome) {
  if (!prev) return true;
  if (prev.outcome === 'completed') return false;
  const grew = count > prev.count;
  const escalates = outcome === 'completed';
  return grew || escalates;
}
